<template>
  <div id="ht-wrap"></div>
</template>

<script>
export default {
  name: "towerMonitor",
  data(){
    return{

    }
  },
  beforeCreate() {
    window.htUrl('ht-towerMonitor');
  },
  mounted() {
    this.addGraphView();
  },
  methods: {
    addGraphView() {
      this.dataModel = new ht.DataModel();  // 数据容器
      this.graphView = new ht.graph.GraphView(this.dataModel); // 2d 绑定数据模型
      this.dm = this.graphView.dm();
      this.g3d = new ht.graph3d.Graph3dView();         //3d
      this.g3d.addToDOM(document.getElementById('ht-wrap'));
      this.graphView.addToDOM(this.g3d.getView());
      let _this = this;
      this.g3d.deserialize('scenes/1000-ton drilling platform HT.json', function (json, dm, g3d, datas) {
        _this.g3d.setEye(-611, 222, -853);
        _this.g3d.setCenter(86, 145, 2);
        _this.g3d.setFar(1000000);
      })
      console.log(this.g3d)
    }
  }
}
</script>

<style scoped lang="scss">
#ht-wrap{
  position: relative;
  width: 100%;
  height: 800px;
}
</style>
